// extracted by mini-css-extract-plugin
export var anticlockwise = "b9_jX";
export var svg = "b9_jV";
export var wrapper = "b9_B";
export var wrapperFlexCenter = "b9_jW";